import src from "IMAGE";
export default { src, width: 664, height: 200, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQUlEQVR42h2KORLAIAzEKGHWYU0MTY4nZAL//xyGQoVGCuPFD+EdE4oc1MyzUm2zPPQHH5CvmMR8pIempbY1OjYBmAoEc/V2o+8AAAAASUVORK5CYII="};
